import React from 'react';
import { fullYear } from '../../../utils/helper-functions';

import styles from './copy-write.module.css';

const CopyWrite = () => {
  return (
    <span className={styles.copywrite}>
      &copy; {fullYear()} JK Design. All rights reserved.
    </span>
  );
};

export default CopyWrite;



// WEBPACK FOOTER //
// ./src/components/footer/copy-write/index.js